<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'recover' | lang }}</div>
    </header>
    <div>
      <div class="small-form">
        <div class="floating-label">
          <input v-model="this.urlParams.email" placeholder=" " type="text" disabled />
          <label>{{ 'Email' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="newpassword" placeholder=" " :type="showNewPassword ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: passwordErrors.all }" :disabled="status === 'success'" />
          <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showNewPassword, 'fa-eye': !showNewPassword }" @click="showNewPassword = !showNewPassword"></i>
          <label>{{ 'NewPassword' | lang }}</label>
        </div>
        <div>
          {{ 'PasswordConditions' | lang }}
          <ul id="password-errors">
            <li :class="{ 'text-green': !passwordErrors.maiuscola, 'text-red': passwordErrors.maiuscola }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.maiuscola, 'fa-exclamation-triangle': passwordErrors.maiuscola }"></i>&nbsp;Almeno una lettera maiuscola
            </li>
            <li :class="{ 'text-green': !passwordErrors.minuscola, 'text-red': passwordErrors.minuscola }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.minuscola, 'fa-exclamation-triangle': passwordErrors.minuscola }"></i>&nbsp;Almeno una lettera minuscola
            </li>
            <li :class="{ 'text-green': !passwordErrors.cifra, 'text-red': passwordErrors.cifra }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.cifra, 'fa-exclamation-triangle': passwordErrors.cifra }"></i>&nbsp;Almeno una cifra
            </li>
            <li :class="{ 'text-green': !passwordErrors.simbolo, 'text-red': passwordErrors.simbolo }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.simbolo, 'fa-exclamation-triangle': passwordErrors.simbolo }"></i>&nbsp;Almeno un simbolo tra !@#$&amp;*.:
            </li>
            <li :class="{ 'text-green': !passwordErrors.lunghezza, 'text-red': passwordErrors.lunghezza }">
              <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.lunghezza, 'fa-exclamation-triangle': passwordErrors.lunghezza }"></i>&nbsp;Almeno 8 caratteri
            </li>
          </ul>
        </div>
        <div class="floating-label">
          <input v-model="newpassword2" placeholder=" " :type="showNewPassword2 ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: password2Errors.all }" :disabled="status === 'success'" />
          <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showNewPassword2, 'fa-eye': !showNewPassword2 }" @click="showNewPassword2 = !showNewPassword2"></i>
          <label>{{ 'NewPasswordRepeat' | lang }}</label>
        </div>
        <ul id="password-errors">
          <li v-if="!password2Errors.match" class="text-green">
            <i class="fa fa-fw fa-check"></i>&nbsp;{{ 'PasswordsMatch' | lang }}
          </li>
          <li v-else class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'PasswordsMismatch' | lang }}
          </li>
        </ul>
        <div v-if="status">
          <div v-if="status === 'waiting'">
            <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
          </div>
          <div v-else-if="status === 'error'" class="text-red">
            <i class="fa fa-fw fa-exclamation-triangle"></i>{{ 'errorOccured' | lang }}
          </div>
          <div v-else-if="status === 'success'" class="text-green">
            <i class="fa fa-fw fa-check"></i>{{ 'PasswordUpdated' | lang }}
          </div>
        </div>
      </div>
    </div>
    <footer>
      <button class="full-width" @click="recover" :disabled="!isLogged || invalidForm || isWaiting" v-if="status !== 'success'">{{ 'Save' | lang }}</button>
      <button v-else @click="goTo('/', true)">{{ 'Done' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'PasswordRecoveryEnd',
  mixins: [ page, UserServices ],
  data () {
    return {
      status: '',
      newpassword: '',
      newpassword2: '',
      showNewPassword: false,
      showNewPassword2: false
    }
  },
  computed: {
    invalidForm () {
      return this.passwordErrors.all || this.password2Errors.all
    },
    invalidEmail () {
      return !this.checkEmailValidity(this.email)
    },
    isWaiting () {
      return this.status === 'waiting'
    },
    urlParams () {
      return { email: this.$route.query.email, restoreToken: this.$route.query.token }
    },
    passwordErrors () {
      /* if(/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/.test(this.password)) {
        return null
      } */
      let maiuscola = !(/[A-Z]/.test(this.newpassword))
      let minuscola = !(/[a-z]/.test(this.newpassword))
      let simbolo = !(/[!@#$&*.:]/.test(this.newpassword))
      let cifra = !(/[0-9]/.test(this.newpassword))
      let lunghezza = !(/^.{8,}$/.test(this.newpassword))
      return {
        maiuscola, minuscola, simbolo, cifra, lunghezza, all: maiuscola || minuscola || simbolo || cifra || lunghezza
      }
    },
    password2Errors () {
      let match = this.newpassword !== this.newpassword2
      return {
        match, all: match
      }
    }
  },
  methods: {
    recover () {
      this.showPassword = false
      this.status = 'waiting'
      this._completePasswordReinitialization(this.urlParams.email, this.urlParams.restoreToken, this.newpassword).then(data => {
        this.status = 'success'
        console.log(data)
        /* setTimeout(() => {
          this.goTo(this.waitingLoginPage, true, true)
          this.waitingLoginPage = null
        }, 700) */
      }).catch(err => {
        this.status = 'error'
        console.log(err)
      })
    }
  },
  beforeDestroy () {},
  async mounted () {
    this.user = await this._doAnonymousLogin()
  },
  watch: {
    showOldPassword (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowOldPassword)
        this.timeoutShowOldPassword = setTimeout(() => {
          this.showOldPassword = false
        }, 2000)
      }
    },
    showNewPassword (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowNewPassword)
        this.timeoutShowNewPassword = setTimeout(() => {
          this.showNewPassword = false
        }, 2000)
      }
    },
    showNewPassword2 (newV, oldV) {
      if (newV && !oldV) {
        clearTimeout(this.timeoutShowNewPassword2)
        this.timeoutShowNewPassword2 = setTimeout(() => {
          this.showNewPassword2 = false
        }, 2000)
      }
    }
  }
}
</script>

<style></style>
